import { useEffect, useRef } from 'react';

export default function HeroSection() {
  const heroRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleScroll = () => {
      if (!heroRef.current) return;
      const scrollY = window.scrollY;
      const opacity = Math.max(0, 1 - scrollY / 600);
      heroRef.current.style.opacity = String(opacity);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section
      ref={heroRef}
      className="relative min-h-[90vh] flex items-center overflow-hidden bg-gp-graphite"
    >
      <div className="absolute inset-0">
        <img
          src="/images/TRABALHE-CONOSCO/HERO/HERO-TRABALHE-CONOSCO.webp"
          alt="Equipe Pilar de profissionais industriais com EPIs completos caminhando em instalação industrial moderna demonstrando união profissionalismo e segurança"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-gp-graphite via-gp-graphite/80 to-gp-graphite/60"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-gp-graphite via-transparent to-transparent"></div>
      </div>

      <div className="relative z-10 w-full px-4 sm:px-6 lg:px-12 pt-24">
        <div className="max-w-3xl">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-12 h-[2px] bg-gp-yellow"></div>
            <span className="text-gp-yellow text-sm uppercase tracking-[0.3em] font-medium">Carreiras</span>
          </div>

          <h1 className="font-display text-5xl md:text-7xl lg:text-8xl font-bold text-white uppercase leading-[0.95] mb-8">
            Faça Parte da<br />
            <span className="text-gp-yellow">Nossa Equipe</span>
          </h1>

          <p className="text-gray-300 text-lg md:text-xl max-w-2xl leading-relaxed mb-10">
            Estamos sempre em busca de profissionais comprometidos, responsáveis e apaixonados por desafios industriais.
            Venha crescer conosco e construir uma carreira sólida em uma empresa que valoriza pessoas, segurança e excelência operacional.
          </p>

          <a
            href="#formulario"
            className="inline-flex bg-gp-yellow hover:bg-gp-yellow-dark text-gp-graphite px-8 py-4 rounded-sm font-semibold text-sm uppercase tracking-wider transition-all duration-300 hover:scale-105 whitespace-nowrap"
          >
            Enviar Currículo
            <i className="ri-arrow-down-line w-5 h-5 flex items-center justify-center ml-2"></i>
          </a>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <a href="#porque" className="text-gray-500 hover:text-gp-yellow transition-colors duration-300">
          <i className="ri-arrow-down-line text-2xl w-8 h-8 flex items-center justify-center"></i>
        </a>
      </div>
    </section>
  );
}